import { render, staticRenderFns } from "./SummaryNextStepsTab.vue?vue&type=template&id=c4741f90&scoped=true"
import script from "./SummaryNextStepsTab.vue?vue&type=script&lang=ts"
export * from "./SummaryNextStepsTab.vue?vue&type=script&lang=ts"
import style0 from "./SummaryNextStepsTab.vue?vue&type=style&index=0&id=c4741f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4741f90",
  null
  
)

export default component.exports